module.exports = __webpack_public_path__ + "static/media/logo.19bd1411.svg";